const behavioralSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Overview of Behavioral Interviews</h3>
      <ul className="list-disc pl-6">
        <li>
          Behavioral interviews assess a candidate's communication, problem-solving, and teamwork
          skills.
        </li>
        <li>
          They focus on past experiences and how candidates handle various workplace scenarios.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Common Behavioral Questions</h3>
      <ul className="list-disc pl-6">
        <li>“Tell me about a time you faced a challenge and how you handled it.”</li>
        <li>“Describe a situation where you worked in a team and resolved a conflict.”</li>
        <li>
          “Give an example of a time when you received critical feedback and how you responded.”
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to Structure Your Answers</h3>
      <ul className="list-disc pl-6">
        <li>
          Use the <strong>STAR Method</strong> to structure responses:
        </li>
        <ul className="list-disc pl-6 mt-1">
          <li>
            <strong>Situation:</strong> Describe the context of the experience.
          </li>
          <li>
            <strong>Task:</strong> Explain the challenge or responsibility you had.
          </li>
          <li>
            <strong>Action:</strong> Detail the steps you took to address the situation.
          </li>
          <li>
            <strong>Result:</strong> Share the outcome and what you learned.
          </li>
        </ul>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Key Traits Employers Look For</h3>
      <ul className="list-disc pl-6">
        <li>
          <strong>Communication:</strong> Clearly articulating thoughts and ideas.
        </li>
        <li>
          <strong>Problem-Solving:</strong> Demonstrating analytical thinking in difficult
          situations.
        </li>
        <li>
          <strong>Teamwork:</strong> Collaborating effectively with others.
        </li>
        <li>
          <strong>Adaptability:</strong> Handling change and uncertainty in the workplace.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Preparation Tips</h3>
      <ul className="list-disc pl-6">
        <li>Practice answering common behavioral questions using the STAR method.</li>
        <li>Reflect on past experiences to prepare relevant stories.</li>
        <li>Be concise and focus on measurable outcomes.</li>
      </ul>
    </div>
  </div>
);

export default behavioralSummary;
